<div id="product-search">
  <paging
  [len]="len"
  [page]="page"
  [config]="config"
  [totalItems]="total"
  (changePage)="handleOnChangePage($event);"
  (totalPage)="onTotalPage($event)"
  (changeLen)="handleOnChangeLenSelected($event)"
  [turnOnTotalPage]="true"
  [turnOnPagination]="false"
  [turnOnTotalItem]="true"
  [isMobile]="true"
  [pdtLen]="true"
  ></paging>
  <products [products]="products" [config]="config" [urlWownet]="urlWownet"></products>
  <paging
  [len]="len"
  [page]="page"
  [config]="config"
  [totalItems]="total"
  (changePage)="handleOnChangePage($event);"
  (totalPage)="onTotalPage($event)"
  (changeLen)="handleOnChangeLenSelected($event)"
  [turnOnTotalPage]="true"
  [turnOnPagination]="true"
  [turnOnTotalItem]="true"
  [isMobile]="false"
  [pdtLen]="true"
  ></paging>
</div>